<template>
  <div class="bg-white h-full z-50" v-if="show">
    <div class="relative w-full h-16">
      <img v-if="show" @click="displayMobileMenu(false)" class="close-icon cursor-pointer absolute" src="../../../assets/img/close.svg" height="50" width="30" alt="">
      <ul class="px-6 py-4">
        <li>
          <img class="cursor-pointer" src="../../../assets/img/algo-mart.png" height="50" width="150" alt="">
        </li>
      </ul>
    </div>
    <ul class="top-navigation px-4 py-2">
      <li class="px-4 py-2 mb-2">
        <avatar :size="30" username="Jane Doe"></avatar> <span class="ml-2">Joe Doe</span>
      </li>
      <li class="px-4 pt-4 pb-2 mb-2">
        <el-badge value="0" class="item">
          <i class="el-icon-message-solid text-2xl text-gray-500"></i>
        </el-badge>
        <span class="ml-2">Notification</span>
      </li>
      <li class="px-4 py-2 mb-2">
        <i class="el-icon-s-tools text-2xl text-gray-500"></i>
        <span class="ml-2">Settings</span>
      </li>
      <li class="px-4 py-2 mb-2">
        <i class="el-icon-switch-button text-2xl text-gray-500"></i>
        <span class="ml-2">Logout</span>
      </li>
    </ul>
    <div class="border-t-2 border-gray-500"></div>
    <ul class="side-navigation px-4 py-2">
      <li @click="displayMobileSubMenu('true', 'Dashboard')" class="px-4 py-2 mb-2" :class="{'current-route': $route.name.includes('dashboard')}"><i class="fas fa-tachometer-alt text-gray-500 text-2xl mr-2"></i>
        Dashboard <i class="el-icon-arrow-right float-right mt-2"></i>
      </li>
      <li @click="displayMobileSubMenu('true', 'Ecommerce')" class="px-4 py-2 mb-2"><i class="el-icon-shopping-cart-1 text-gray-500 text-2xl mr-2"></i> E-Commerce
        <i class="el-icon-arrow-right float-right mt-2"></i>
      </li>
      <li @click="displayMobileSubMenu('true', 'Customer')" class="px-4 py-2 mb-2"><i class="fas fa-users-cog text-gray-500 text-2xl mr-2"></i> Customer Analytics
        <i class="el-icon-arrow-right float-right mt-2"></i>
      </li>
      <li @click="displayMobileSubMenu('true', 'Geospatial')" class="px-4 py-2 mb-2"><i class="fas fa-map-marked-alt text-gray-500 text-2xl mr-2"></i> Geospatial
        <i class="el-icon-arrow-right float-right mt-2"></i>
      </li>
      <li @click="displayMobileSubMenu('true', 'Recommendation')" class="px-4 py-2 mb-2"><i class="fas fa-thumbs-up text-gray-500 text-2xl mr-2"></i> Recommendation System
        <i class="el-icon-arrow-right float-right mt-2"></i>
      </li>
      <li class="px-4 py-2 mb-2"><i class="fas fa-chart-line text-gray-500 text-2xl mr-2"></i>
        Sales Prediction <el-tag class="float-right" :type="'warning'" size="mini">coming soon</el-tag>
      </li>
    </ul>
  </div>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
  name: 'PageNavigation',
  computed: {
    show() {
      return this.$store.state.Global.mobileMenu;
    },
  },
  components: {
    Avatar,
  },
  methods: {
    /**
     *
     * @param value
     * @returns {Promise<void>}
     */
    async displayMobileMenu(value) {
      await this.$store.commit('Global/setProperty', { property: 'mobileMenu', payload: value });
    },

    /**
     *
     * @param value
     * @param key
     * @returns {Promise<void>}
     */
    async displayMobileSubMenu(value, key) {
      await this.displayMobileMenu(false);
      await this.$store.commit('Global/setProperty', { property: 'subMobileMenu', payload: value });
      await this.$store.commit('Global/setProperty', { property: 'currentSelectedSubMenu', payload: key });
    },
  },
};
</script>

<style scoped lang="scss">
  .close-icon {
    right: 20px;
    top: 20px;
  }

  .vue-avatar--wrapper {
    display: inline-block !important;
  }

    .top-navigation, .side-navigation {
      li {
        cursor: pointer;

        &:hover {
          background: #ecf5ff;
        }
      }
    }
</style>
